<div class="portal--header">
    <h1 class="heading">Meter portfolio</h1>
    <button id="toggle-button" class="focus-element text-light" collapsible [collapsibleSection]="collapsibleReadDataSection" [isCollapsed]="isReadDataCollapsed" [collapsibleTitle]="collapsibleReadDataTitle">
        <span class="focus--content" tabindex="-1">
            <span class='accordion-toggle' #collapsibleReadDataTitle style="margin-top: 0; font-size:2rem">Download meter readings <svg class="ic-arrow"><use xlink:href="#ic-arrow-white" href="#ic-arrow-white"></use></svg></span>
        </span>
    </button>
    <div class="flex-grid--item">
        <div class="collapsible" #collapsibleReadDataSection>
            <div style="background-color:white;padding:1rem">
                <h2 class="subheading-sm">Download meter readings <button class="info-btn focus-element" (click)="onInfoClick()"><span class="focus--content" tabindex="-1"><span>i</span></span></button></h2>
                <form class="std-form" [formGroup]="form" (submit)="submit(form)" autocomplete="off" novalidate>
                    <div class="row">
                        <div class="col-md-6 col-sm-6 col-xs-12">
                            <div class="form-group">
                                <label for="start-date">Start date</label>
                                <input type="text" id="start-date" placeholder="dd/mm/yyyy" [textMask]="{mask: dateMask, pipe: dateAutoCorrectPipe, guide: false}" [formControl]="form.controls['startDate']">
                                <ng-container *ngIf="submitted">
                                    <span *ngIf="form.controls['startDate'].hasError('required') || form.controls['startDate'].hasError('date')" class="validation-msg">Please provide a valid date</span>
                                </ng-container>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-sx-12">
                            <div class="form-group">
                                <label for="end-date">End date</label>
                                <input type="text" id="end-date" placeholder="dd/mm/yyyy" [textMask]="{mask: dateMask, pipe: dateAutoCorrectPipe, guide: false}" [formControl]="form.controls['endDate']">
                                <ng-container *ngIf="submitted">
                                    <span *ngIf="form.controls['endDate'].hasError('required') || form.controls['endDate'].hasError('date')" class="validation-msg">Please provide a valid date</span>
                                </ng-container>
                            </div>
                        </div>
                        <div class="col-md-12 col-sm-12 col-xs-12">
                            <div class="form-group">
                                <label>Meter type</label>
                                <div class="input-inline">
                                    <div class="checkbox">
                                        <input type="radio" id="allMeterType" value="all" name="meterType" [formControl]="form.controls['meterType']" />
                                        <label for="allMeterType"><div class="check"><svg class="ic-check"><use xlink:href="#ic-check-light" href="#ic-check-light"></use></svg></div>All</label>
                                    </div>
                                    <div class="checkbox">
                                        <input type="radio" id="domestic" value="domestic" name="meterType" [formControl]="form.controls['meterType']" />
                                        <label for="domestic"><div class="check"><svg class="ic-check"><use xlink:href="#ic-check-light" href="#ic-check-light"></use></svg></div>Domestic</label>
                                    </div>
                                    <div class="checkbox">
                                        <input type="radio" id="bulk" value="bulk" name="meterType" [formControl]="form.controls['meterType']" />
                                        <label for="bulk"><div class="check"><svg class="ic-check"><use xlink:href="#ic-check-light" href="#ic-check-light"></use></svg></div>Bulk</label>
                                    </div>
                                    <span *ngIf="form.controls['meterType'].hasError('required') && submitted" class="validation-msg">Meter type is required to be set</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-xs-12">
                            <div class="form-group">
                                <label for="sites">Select site</label>
                                <select name="client" id="" class="select__standalone" [formControl]="form.controls['siteId']">
                                    <option [value]="site.siteId" *ngFor="let site of sites">{{site.siteName}}</option>
                                </select>
                                <ng-container *ngIf="submitted">
                                    <span *ngIf="form.controls['siteId'].hasError('required')" class="validation-msg">Please provide a site</span>
                                </ng-container>
                            </div>
                        </div>
                        <div class="col-md-12 col-sm-12 col-xs-12">
                            <div class="form-group">
                                <label class="text-light">Supply</label>
                                <div class="input-inline">
                                    <div class="checkbox" *ngFor="let readDataFilter of readDataFilterList; let readDataIndex = index">
                                        <input type="radio" [id]="readDataFilter.key" [value]="readDataFilter.key" [formControl]="form.controls['supplyType']" name="supplyType" />
                                        <label [for]="readDataFilter.key"><div class="check"><svg class="ic-check"><use xlink:href="#ic-check-light" href="#ic-check-light"></use></svg></div>{{readDataFilter.label}}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button class="std-btn focus-element" type="submit">
                        <span class="focus--content" tabindex="-1">{{submitting ? 'Downloading...' : 'Download'}}</span>
                    </button>
                    <p>Please note this may take a while.</p>
                </form>
            </div>
        </div>
    </div>
</div>
<div class="portal--main">
    <div class="flex-grid space-between bottom stack-sm">
        <div class="flex-grid--item">
            <button id="toggle-button" class="focus-element" collapsible [collapsibleSection]="collapsibleSection" [collapsibleTitle]="collapsibleTitle"><span class="focus--content" tabindex="-1"><span class='accordion-toggle open' #collapsibleTitle style="margin-top: 0;">Filter <svg class="ic-arrow"><use xlink:href="#ic-arrow" href="#ic-arrow"></use></svg></span></span></button>
            <div class="collapsible" #collapsibleSection>
                <div class="btn-group">
                    <ng-container *ngFor="let filter of filterList; let i = index">
                        <button class="std-btn filter focus-element" [ngClass]="{'active': filterList[i].isClicked}" (mouseup)="filterUpdated(i)"><span class="focus--content" tabindex="-1">{{filter.label}} <span class="detail"></span></span></button>
                    </ng-container>
                </div>
            </div>
        </div>
        <div class="flex-grid--item organise-select">
            <label for="">Site:</label>
            <select name="siteId" id="" class="select__standalone" [(ngModel)]="selectedSiteId" (change)="updateSite()" #siteId>
                <option [ngValue]="0">All</option>
                <option [ngValue]="site.siteId" *ngFor="let site of sites">{{site.siteName}}</option>
            </select>
        </div>
    </div>
    <div class="module drop-shadow bottom summary__module half">
        <div class="module--main third">
            <div class="block-num text-center">
                <svg class="ic"><use xlink:href="#ic-meter" href="#ic-meter"></use></svg>
                <h2 class="subheading-sm">Total active Meters</h2>
                <ng-container>
                    <span class="lg">
                        {{totalRegisters}}
                    </span>
                </ng-container>
            </div>
        </div>
        <div class="module--main third">
            <div class="block-num text-center">
                <svg class="ic"><use xlink:href="#ic-meter" href="#ic-meter"></use></svg>
                <h2 class="subheading-sm">New / replacement Meters</h2>
                <div class="summary__module--flex">
                    <div class="flex--item">
                        <span class="lg">{{newRegistersLy}}</span>
                        <span>Last calendar year</span>
                    </div>
                    <div class="flex--item">
                        <span class="lg">{{newRegistersTy}}</span>
                        <span>This calendar year</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <hr>
    <div class="flex-grid end stack-sm">
        <div class="flex-grid--item organise-select">
            <label for="">View:</label>
            <select name="timePeriod" id="" class="select__standalone" (change)="updateTimeperiod($event.target.value)" #timePeriod>
                <option value="12" selected>Monthly (1 year)</option>
                <option value="90">Daily (90 days)</option>
            </select>
        </div>
    </div>
    <masonry [masonryItems]="masonryItems" [masonryColumnCount]="1"></masonry>
</div>
